import { useState } from 'react';
import { faqItems } from '@/mocks/manga';

const faqLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: { '@type': 'Answer', text: item.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="mx-auto w-full max-w-4xl scroll-mt-20 px-4 py-16 md:px-6 md:py-24">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqLd) }}
      />
      <div className="text-center">
        <span className="text-sm font-medium text-primary-600">HELP CENTER</span>
        <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">常见问题</h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          关于178漫画网的推荐机制、投稿与使用方式，这里都有答案。
        </p>
      </div>

      <div className="mt-10 flex flex-col gap-3">
        {faqItems.map((item, idx) => {
          const open = openIdx === idx;
          return (
            <div
              key={item.q}
              className="overflow-hidden rounded-lg border border-background-200 bg-background-100"
            >
              <button
                type="button"
                onClick={() => setOpenIdx(open ? -1 : idx)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
              >
                <span className="text-sm font-medium text-foreground-950 md:text-base">{item.q}</span>
                <i
                  className={`text-lg text-primary-600 transition-transform ${open ? 'ri-subtract-line' : 'ri-add-line'}`}
                  aria-hidden="true"
                ></i>
              </button>
              {open && (
                <div className="border-t border-background-200 px-5 py-4">
                  <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}